import CustomKendoWindow from "./CustomKendoWindow";
import ProctorKendoWindow from "./ProctorKendoWindow";
import widgetTemplate from '../../templates/widgetTemplate.html';

export default class DockManager {

    constructor(context) {
        this.context = context;
        this.dockedWindows = new Map();
        this.overflowWindows = new Map();
        this.addOverflow();
		$(window).off('resize',this.handleWindowResize.bind(this)).on('resize',this.handleWindowResize.bind(this));
    }

    dockWindow(testerIdentifier) {
        this.dockedWindows.set(testerIdentifier);
		if(this.dockedWindows.size > DockManager.getMaxDockCount()) {
            //undock and add to overflow
            this.dockedWindows.delete(testerIdentifier);
            let overflowContainer = $('#overflowContainer');
			let overflowElement = this.buildOverflowElement(testerIdentifier);
            overflowContainer.append(overflowElement);
			this.overflowWindows.set(testerIdentifier, overflowElement);
            this.updateDockBaseOverflowElement();
            this.context.kendoWindows.get(testerIdentifier).kendoWindow.wrapper.hide();
			this.overflowDiv.show();
            this.overflowDiv.trigger('focus');
        }
    }

	handleWindowResize() {
		this.reprocessDockedWindows();
	}

	unDockWindow(testerIdentifier) {
		if(!this.dockedWindows.has(testerIdentifier)) {
			return;
		}
		this.dockedWindows.delete(testerIdentifier);
		this.context.kendoWindows.get(testerIdentifier).kendoWindow.restore();
		//if there are any overflow widgets, grab the newest one out and dock it
		if(this.overflowWindows.size > 0) {
			let mostRecentOverflow = Array.from(this.overflowWindows.keys()).pop();
			this.dockedWindows.set(mostRecentOverflow);
			this.context.kendoWindows.get(mostRecentOverflow).kendoWindow.wrapper.show();
			this.removeFromOverflow(mostRecentOverflow);
		}
		this.reprocessDockedWindows();
	}

	removeFromOverflow(identifier) {
		let overflowToRemove = this.overflowWindows.get(identifier);
		this.overflowWindows.delete(identifier);
		overflowToRemove.trigger('clear-unseen-chats');
		overflowToRemove.remove();
		//reset the remaining overflow positions
		let count = 0;
		let top = window.innerHeight - this.overflowDiv.height() - DockManager.getVerticalOffset();
		for(let key of this.overflowWindows.keys()) {
			let newTop = top - (++count * (this.overflowDiv.height() + DockManager.getVerticalOffset()));
			$('#overflowContainer').find(`[data-identifier='${key}']`).css('top', newTop);
		}
		this.updateDockBaseOverflowElement();
		if(this.overflowWindows.size < 1) {
			this.overflowDiv.hide();
		}
	}

	closeFromOverflow(e) {
		let kendoWindow = this.dockContext.context.kendoWindows.get(this.identifier).kendoWindow;
		kendoWindow.wrapper.show();
		kendoWindow.restore();
		kendoWindow.close();
		this.dockContext.removeFromOverflow(this.identifier);
	}

	closeAllFromOverflow() {
		for(let overflow of this.overflowWindows.values()) {
			overflow.find('.close-overflow-element').trigger('click');
		}
	}

	expandWindow(testerIdentifier) {
		//if the window that we are expanding isn't docked, then just restore it normally
		if(!this.dockedWindows.has(testerIdentifier)) {
			this.context.kendoWindows.get(testerIdentifier).kendoWindow.restore();
			return;
		}
		let windowToExpand = this.context.kendoWindows.get(testerIdentifier).kendoWindow;
		let top = window.innerHeight - ProctorKendoWindow.getHeight() - DockManager.getVerticalOffset();
		DockManager.resizeAndupdateWindowPosition(windowToExpand, null, top);
		this.context.kendoWindows.get(testerIdentifier).kendoWindow.wrapper.trigger('clear-unseen-chats');
	}

	reprocessDockedWindows() {
		let dockedWidth = ProctorKendoWindow.getWidth();
		let left = DockManager.getDefaultLeftPosition();
		for(let key of this.dockedWindows.keys()) {
			let kendoWindow = this.context.kendoWindows.get(key).kendoWindow;
			DockManager.resizeAndupdateWindowPosition(kendoWindow, left, window.innerHeight - kendoWindow.wrapper[0].clientHeight - DockManager.getVerticalOffset());
			kendoWindow.wrapper.removeClass('k-focus');
			left += dockedWidth + DockManager.getHorizontalPaddingAmount();
		}

		this.overflowDiv.css('top', window.innerHeight - (this.overflowDiv.height()) - DockManager.getVerticalOffset());
		let index = 1;
		for(let overflowElement of this.overflowWindows.values()) {
			let top = this.overflowDiv.position().top - (index++ * (this.overflowDiv.height() + DockManager.getVerticalPaddingAmount() + 2));
			overflowElement.css('top', top);
		}
	}

	// this function updates the css position and the kendo position.  Updating the kendo position is important because it keeps the drag location in sync with the window location.
	static resizeAndupdateWindowPosition(kendoWindow, left, top) {
		kendoWindow.wrapper.css('width', ProctorKendoWindow.getWidth());
		if(!kendoWindow.isMinimized()) {
			kendoWindow.wrapper.css('height', ProctorKendoWindow.getHeight());
		}
		kendoWindow.options.width = kendoWindow.wrapper.css('width');
		kendoWindow.options.height = kendoWindow.wrapper.css('height');
		DockManager.updateWindowPosition(kendoWindow, left, top);

	}

	static updateWindowPosition(kendoWindow, left, top) {
		if(left >= 0) {
			kendoWindow.wrapper.css('left', left);
			kendoWindow.options.position.left = left;
		}
		if(top >= 0) {
			kendoWindow.wrapper.css('top', top);
			kendoWindow.options.position.top = top;
		}
	}

	addOverflow() {
		//first, create the overflow box
		this.overflowDiv = $(this.buildOverflowTemplate());
		$('body').append(this.overflowDiv);
		this.overflowDiv.css('top', window.innerHeight - (this.overflowDiv.height()) - DockManager.getVerticalOffset());

		//now create the overflow student list that will be toggled when the overflow div is clicked.
		let container = $('<div>').attr({'id' : 'overflowContainer', 'tabindex' : '0'}).css({ 'position' : 'fixed', 'left' : this.overflowDiv.css('left'), 'top' : this.overflowDiv.css('top')}).hide();
		$('body').append(container);

		this.overflowDiv.off('focus', this.overflowFocusHandler.bind(this)).on('focus', this.overflowFocusHandler.bind(this));
		this.overflowDiv.off('blur', this.overflowBluerHandler.bind(this)).on('blur', this.overflowBluerHandler.bind(this));
		$('#overflowContainer').off('blur', this.overflowContentBlurHandler.bind(this)).on('blur', this.overflowContentBlurHandler.bind(this));
		this.overflowDiv.off('click', this.overflowContentClickHandler.bind(this)).on('click', this.overflowContentClickHandler.bind(this));
		this.overflowDiv.off('chat-received', this.overflowChatHandler.bind(this)).on('chat-received', this.overflowChatHandler.bind(this));
		this.overflowDiv.off('clear-unseen-chats', this.overflowClearUnseenChatHandler.bind(this)).on('clear-unseen-chats', this.overflowClearUnseenChatHandler.bind(this));
		$('#overflow-close-all').off('click', this.closeAllFromOverflow.bind(this)).on('click', this.closeAllFromOverflow.bind(this));
	}

	buildOverflowElement(testerIdentifier) {
		let template = this.buildOverflowElementTemplate(testerIdentifier);
		let element = $(template);
		//this.positionOverflowElement(element, this.overflowWindows.size);
		element.off('click', this.overflowElementClickHandler.bind(this)).on('click', this.overflowElementClickHandler.bind(this));
		element.off('chat-received', this.overflowElementChatHandler.bind(this)).on('chat-received', this.overflowElementChatHandler.bind(this));
		element.off('clear-unseen-chats', this.overflowElementClearUnseenChatHandler.bind(this)).on('clear-unseen-chats', this.overflowElementClearUnseenChatHandler.bind(this));
		element.off('lower-hand', this.overflowElementLowerHandHandler.bind(this)).on('lower-hand', this.overflowElementLowerHandHandler.bind(this));
		element.off('raise-hand', this.overflowElementRaiseHandHandler.bind(this)).on('raise-hand', this.overflowElementRaiseHandHandler.bind(this));
		element.find('.close-overflow-element').off('click', this.closeFromOverflow.bind({dockContext : this, identifier : testerIdentifier})).on('click', this.closeFromOverflow.bind({dockContext : this, identifier : testerIdentifier}));
		return element;
	}

	buildOverflowTemplate() {
		let width = `${ProctorKendoWindow.getWidth()}px;`;
		let left = `${DockManager.getDefaultLeftPosition() + (DockManager.getMaxDockCount()) * (ProctorKendoWindow.getWidth() + DockManager.getHorizontalPaddingAmount())}px;`;
		let template = _.template($(widgetTemplate).filter("#dockManagerOverflow").html());
		return template({width : width, left : left});
	}

	buildOverflowElementTemplate(testerIdentifier) {
		let isIconHandRaised = this.context.kendoWindows.get(testerIdentifier).isIconHandRaised;
		let width = `${ProctorKendoWindow.getWidth()}px;`;
		let title = this.context.kendoWindows.get(testerIdentifier).testerName;
		let raiseHandDisplayStyle = isIconHandRaised ? 'style="display: none;"' : '';
		let lowerHandDisplayStyle = !isIconHandRaised ? 'style="display: none;"' : '';
		let template = _.template($(widgetTemplate).filter("#dockManagerOverflowElement").html());
		return template({testerIdentifier : testerIdentifier, width : width, title : title, raiseHandDisplayStyle : raiseHandDisplayStyle, lowerHandDisplayStyle : lowerHandDisplayStyle});
	}

	updateDockBaseOverflowElement() {
		let isOverflowHandRaised = false;
		for (let key of this.overflowWindows.keys()) {
			if (this.context.kendoWindows.get(key).isIconHandRaised) {
				isOverflowHandRaised = true;
				break;
			}
		}
		//now we know that at least 1 overflow tester has a hand raised.  Make the base element's hand raise too
		if (isOverflowHandRaised) {
			$('#overflowRaiseHandButton').hide();
			$('#overflowLowerHandButton').show();
		} else {
			$('#overflowLowerHandButton').hide();
			$('#overflowRaiseHandButton').show();
		}
	}

	centerWithOffset(kendoWindow) {
		let numberOfOpenWindows = Array.from(this.context.kendoWindows.values()).reduce((accumulator, window) => accumulator += this.isWindowVisibleAndNotDocked(window) ? 1 : 0, 0);
		let offset = 25 * numberOfOpenWindows;
		let top = kendoWindow.options.position.top = ($(window).height() / 2) - (kendoWindow.wrapper.height() / 2) + offset;
		let left = kendoWindow.options.position.left = ($(document).width() / 2) - (kendoWindow.wrapper.width() / 2) + offset;
		DockManager.resizeAndupdateWindowPosition(kendoWindow, left, top);
		CustomKendoWindow.clamp(kendoWindow);
	}

	isWindowVisibleAndNotDocked(customKendoWindow) {
		return customKendoWindow.kendoWindow.options.visible && !this.isWindowDocked(customKendoWindow.testerIdentifier);
	}

    isWindowDocked(testerIdentifier) {
        return this.dockedWindows.has(testerIdentifier);
    }

	isWindowOverflowed(testerIdentifier) {
		return this.overflowWindows.has(testerIdentifier);
	}

	dragWindow(e, context) {
		$('.k-window-titlebar').css('background-color', '');
		let identifier = $k(e.currentTarget).parent().data('identifier');
		let draggedWindow = context.kendoWindows.get(identifier);
		if(this.dockedWindows.size < 1) {
			return;
		}

		let position = 0;
		for(let key of this.dockedWindows.keys()) {
			position++;
			if(key === identifier) {
				continue;
			}
			let dockedWindow = context.kendoWindows.get(key).kendoWindow;
			if(DockManager.isWithinThreshold(e.screenX, dockedWindow.options.position.left + (ProctorKendoWindow.getWidth() / 2)) && DockManager.isWithinThreshold(e.screenY, dockedWindow.options.position.top)) {
				//now determine if the drag position is to the left or right side of the docked window
				let dockPosition = position;
				dockedWindow.wrapper.find('.k-window-titlebar').css('background-color', '#dddddd');
				draggedWindow.kendoWindow.wrapper.data('dockPosition', dockPosition);
				break;
			} else {
				draggedWindow.kendoWindow.wrapper.find('.k-window-titlebar').css('background-color', '');
				dockedWindow.wrapper.find('.k-window-titlebar').css('background-color', '');
				draggedWindow.kendoWindow.wrapper.data('dockPosition', null);
			}
		}
	}

	reorderDockPositions(testerIdentifier, newPosition) {
		$('.k-window-titlebar').css('background-color', '');
		let index = 0;
		let newPositions = new Map();
		let lastOverflowKey = null;
		let currentDockPosition = Array.from(this.dockedWindows.keys()).indexOf(testerIdentifier) + 1;
		let isMovingRight = this.dockedWindows.has(testerIdentifier) && currentDockPosition < newPosition;
		//if docked windows only has one element, it means that we docked the first window by dragging.  In this case, we can just dock the window and return.
		if(this.dockedWindows.size <= 1) {
			this.dockWindow(testerIdentifier);
			this.reprocessDockedWindows();
			return;
		}

		for(let key of this.dockedWindows.keys()) {
			index++;
			if(key !== testerIdentifier) {
				newPositions.set(key);
			}
			if(index === newPosition) {
				newPositions.delete(key);
				if(isMovingRight) {
					newPositions.set(key);
					newPositions.set(testerIdentifier);
				} else {
					newPositions.set(testerIdentifier);
					newPositions.set(key);
				}
			}
		}
		if(newPositions.size > DockManager.getMaxDockCount()) {
			//remove the last docked element.  It will be added again after the overflow elements.
			lastOverflowKey = Array.from(newPositions.keys()).pop();
			newPositions.delete(lastOverflowKey);
		}
		//clear dockedWindows and overflowWindows.  Re-docking everything will re-build them.
		this.dockedWindows.clear();
		for(let key of this.overflowWindows.keys()) {
			this.removeFromOverflow(key);
			newPositions.set(key);
		}

		//the lastOverflow key is the previously last docked item.  It got pushed into the overflow.  Adding it after the other overflow elements puts it at the top of the list
		if(lastOverflowKey) {
			newPositions.set(lastOverflowKey);
		}
		for(let key of newPositions.keys()) {
			this.dockWindow(key);
		}
		this.reprocessDockedWindows();
	}

	overflowFocusHandler(e) {
		$(e.currentTarget).addClass('k-focus');
	}

	overflowBluerHandler(e) {
		//TODO: figure this out.
		//$(e.currentTarget).removeClass('k-focus');
		//$('#overflowContainer').trigger('blur');
	}

	overflowContentBlurHandler(e) {
		//TODO: figure this out.
		//$(e.currentTarget).hide();
	}

	overflowContentClickHandler(e) {
		$('#overflowContainer').toggle();
	}

	overflowChatHandler(e) {
		let count = 0;
		let that = this;
		$('.overflow-element').each(function(){
			let id = $(this).data('identifier').toString();
			count += that.context.kendoWindows.get(id).unseenChatCount;
		});
		$(e.currentTarget).addClass('highlightChatWindow');
		$(e.currentTarget).find('.unseenChatCount').text(count);
		$(e.currentTarget).find('.unseen-chats-button').show();
	}

	overflowClearUnseenChatHandler(e) {
		//get the sum of all of the overflow elements
		let count = 0;
		let that = this;
		$('.overflow-element').each(function(){
			let id = $(this).data('identifier').toString();
			count += that.context.kendoWindows.get(id).unseenChatCount;
		});
		$(e.currentTarget).find('.unseenChatCount').text(count);
		if(count < 1) {
			$(e.currentTarget).removeClass('highlightChatWindow');
			$(e.currentTarget).find('.unseen-chats-button').hide();
		}
	}

	overflowElementClickHandler(e) {
		let testerIdentifier = $(e.currentTarget).data('identifier').toString();
		this.context.initiateChat(testerIdentifier);
	}

	overflowElementChatHandler(e) {
		let testerIdentifier = $(e.currentTarget).data('identifier').toString();
		$(e.currentTarget).addClass('highlightChatWindow');
		$(e.currentTarget).find('.unseenChatCount').text(this.context.kendoWindows.get(testerIdentifier).unseenChatCount);
		$(e.currentTarget).find('.unseen-chats-button').show();
		this.overflowDiv.trigger('chat-received');
	}

	overflowElementClearUnseenChatHandler(e) {
		let testerIdentifier = $(e.currentTarget).data('identifier').toString();
		this.context.kendoWindows.get(testerIdentifier).kendoWindow.wrapper.trigger('clear-unseen-chats');
		this.overflowDiv.trigger('clear-unseen-chats');
	}

	overflowElementLowerHandHandler(e) {
		$(e.currentTarget).find(':button.lowerHand').hide();
		$(e.currentTarget).find(':button.raiseHand').show();
		this.updateDockBaseOverflowElement();
	}

	overflowElementRaiseHandHandler(e) {
		$(e.currentTarget).find(':button.lowerHand').show();
		$(e.currentTarget).find(':button.raiseHand').hide();
		$(e.currentTarget).addClass('highlightChatWindow');
		$('#overflow').addClass('highlightChatWindow');
		this.updateDockBaseOverflowElement();
	}

	static getDefaultLeftPosition() {
		return 10;
	}

	static getHorizontalPaddingAmount() {
		return 2;
	}

	static getVerticalPaddingAmount() {
		return 3;
	}

	static getMaxDockCount() {
		return 3;
	}

	static getVerticalOffset() {
		return 5;
	}

	static isWithinThreshold(n1, n2) {
		let threshold = ProctorKendoWindow.getWidth() * 0.75;
		return n1 > n2 - threshold && n1 < n2 + threshold;
	}

	static clamp(num, min, max) {
		return Math.min(Math.max(num, min), max);
	}

	cleanupController(){
		$('#overflow').remove();
		$('#overflowContainer').remove();
	}
}